import React, { useState, useEffect, useCallback, useContext } from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Alert from "@mui/material/Alert";
import Select from "@mui/material/Select";
import { GithubPicker, CompactPicker } from "react-color";
import MenuItem from "@mui/material/MenuItem";
import { makeStyles } from "@mui/styles";
import axios from "axios";
import { ADMIN_URL } from "../../utils/constants";
import {
	FormControlLabel,
	Checkbox,
	CircularProgress,
	RadioGroup,
	Radio,
} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import Iphone from "../../assets/colors.png";
import { Home, Settings } from "tabler-icons-react";
import { useAlert } from "react-alert";
import { UserContext } from "../../context/UserContext";
import { useTranslation } from "react-i18next";
import { timezones } from "../../utils/Timezones";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles({
	alert: {
		"& .MuiAlert-message": {
			display: "flex",
			justifyContent: "space-between",
			width: "100%",
		},
	},
	pickerContainer: {
		"& #font-picker": {
			width: "100%!important",
			background: "none!important",
			backgroundColor: "none!important",
			boxShadow: "none!important",
			border: "1px solid #D0D0D0",
			borderRadius: 4,
			padding: 4,
		},

		"& #font-picker button": {
			background: "none!important",
		},
		"& #font-picker ul": {
			background: "fafafa!important",
			boxShadow: "none!important",
		},
	},
	logo: {
		height: "100%",
		objectFit: "contain",
		maxWidth: 100,
		margin: "12px 0px",
	},
	formControl: {
		"& hover": {
			backgroundColor: "#434343",
		},
	},
});

const languageOptions = [
	{ id: "en", name: "English" },
	{ id: "es", name: "Español" },
];
const timezoneOptions = timezones.map((timezone) => ({
	id: timezone,
	name: timezone,
}));

export default function Colors({
	drawerWidth,
	setRun,
	goToPages,
	setGoToPages,
}) {
	const [loading, setLoading] = useState(false);
	const [generalData, setGeneralData] = useState(null);
	const { user } = useContext(UserContext);
	const classes = useStyles();
	const alert = useAlert();
	const navigate = useNavigate();
	const { t } = useTranslation();

	useEffect(() => {
		console.log("NOW ON APPEARANCE");
		setRun(true);
	}, []);

	useEffect(() => {
		if (goToPages) {
			setGoToPages(false);
			navigate("/pages");
		}
	}, [goToPages]);

	const formatFontFamily = (font) => {
		let newFont = [];
		let index = 0;
		for (const char of font.split("")) {
			if (
				char >= "A" &&
				char <= "Z" &&
				index > 0 &&
				!(font[index - 1] >= "A" && font[index - 1] <= "Z")
			) {
				newFont.push(" " + char);
			} else {
				newFont.push(char);
			}
			index += 1;
		}
		return newFont.join("");
	};

	const saveGeneralData = useCallback(async () => {
		setLoading(true);
		try {
			await axios.post(
				ADMIN_URL + "creators",
				{
					...generalData,
					fontFamily: generalData.fontFamily.split(" ").join(""),
				},
				{
					headers: { authorization: localStorage.getItem("token") },
				}
			);
			alert.show(t("general.success"), { type: "success" });
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	}, [generalData]);

	useEffect(() => {
		const getGeneralData = async () => {
			setLoading(true);
			try {
				const res = await axios.get(ADMIN_URL + "creators", {
					headers: { authorization: localStorage.getItem("token") },
				});
				setGeneralData({
					...res.data,
					fontFamily: formatFontFamily(res.data.fontFamily),
				});
			} catch (error) {
				console.log(error);
			}
			setLoading(false);
		};

		getGeneralData();
	}, []);

	return (
		<Box
			component="main"
			sx={{
				flexGrow: 1,
				bgcolor: "background.default",
				p: 3,
				width: { xs: "100%", sm: "calc(100vw - " + drawerWidth + "px)" },
			}}
		>
			<Toolbar />

			<Card variant="outlined">
				<>
					<CardContent>
						<Typography
							sx={{
								fontSize: 14,
								borderBottom: "1px solid #f0f0f0",
								minHeight: "35px",
								marginBottom: "20px",
								marginLeft: "-20px",
								marginRight: "-20px",
								padding: "0px 20px 20px",
							}}
							color="text.secondary"
							gutterBottom
						>
							{t("colors.title")}
						</Typography>
						{generalData && (
							<>
								<Box
									sx={{
										display: "flex",
										justifyContent: "space-between",
										flexFlow: {
											xs: "column-reverse",
											sm: "column-reverse",
											md: "row",
										},
									}}
								>
									<Box sx={{ width: "100%", paddingRight: 2 }}>
										<FormControl
											fullWidth
											variant="standard"
											sx={{ marginTop: 2, marginBottom: 2 }}
											id="main-color"
										>
											<InputLabel
												shrink
												htmlFor="app-color-input"
												sx={{
													marginTop: -2,
													fontWeight: 700,
													textTransform: "uppercase",
													fontSize: 12,
												}}
											>
												{t("general.mainColor")}
											</InputLabel>
											<TextField
												id="app-color-input"
												fullWidth
												disabled={[
													"building",
													"built",

													"publishing",
													"published",
													"inviting",
												].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
												variant="outlined"
												type="color"
												value={generalData.color}
												onChange={(e) => {
													setGeneralData({
														...generalData,
														color: e.target.value,
													});
												}}
											/>
											<Box
												sx={{
													backgroundColor: generalData.color,
													position: "absolute",
													top: "12px",
													left: "12px",
													width: "calc(100% - 24px)",
													height: "16px",
													outline: "1px solid",
													pointerEvents: "none",
													borderRadius: "2px",
												}}
											></Box>
										</FormControl>
										<FormControl
											fullWidth
											variant="standard"
											sx={{ marginTop: 2, marginBottom: 2 }}
										>
											<InputLabel
												shrink
												htmlFor="app-navigation-color-input"
												sx={{
													marginTop: -2,
													fontWeight: 700,
													textTransform: "uppercase",
													fontSize: 12,
												}}
											>
												{t("general.navigationColor")}
											</InputLabel>
											<TextField
												id="app-navigation-color-input"
												fullWidth
												disabled={[
													"building",
													"built",

													"publishing",
													"published",
													"inviting",
												].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
												variant="outlined"
												type="color"
												value={generalData.navigationColor}
												onChange={(e) => {
													setGeneralData({
														...generalData,
														navigationColor: e.target.value,
													});
												}}
											/>
											<Box
												sx={{
													backgroundColor: generalData.navigationColor,
													position: "absolute",
													top: "12px",
													left: "12px",
													width: "calc(100% - 24px)",
													height: "16px",
													outline: "1px solid",
													pointerEvents: "none",
													borderRadius: "2px",
												}}
											></Box>
										</FormControl>
										<FormControl
											fullWidth
											variant="standard"
											sx={{ marginTop: 2, marginBottom: 2 }}
										>
											<InputLabel
												shrink
												htmlFor="app-color-input"
												sx={{
													marginTop: -2,
													fontWeight: 700,
													textTransform: "uppercase",
													fontSize: 12,
												}}
											>
												{t("general.textNavigationColor")}
											</InputLabel>
											<TextField
												id="app-color-input"
												fullWidth
												disabled={[
													"building",
													"built",

													"publishing",
													"published",
													"inviting",
												].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
												variant="outlined"
												type="color"
												value={generalData.navigationTextColor}
												onChange={(e) => {
													setGeneralData({
														...generalData,
														navigationTextColor: e.target.value,
													});
												}}
											/>
											<Box
												sx={{
													backgroundColor: generalData.navigationTextColor,
													position: "absolute",
													top: "12px",
													left: "12px",
													width: "calc(100% - 24px)",
													height: "16px",
													outline: "1px solid",
													pointerEvents: "none",
													borderRadius: "2px",
												}}
											></Box>
										</FormControl>
										<FormControl
											fullWidth
											variant="standard"
											sx={{ marginTop: 2, marginBottom: 2 }}
										>
											<InputLabel
												shrink
												htmlFor="app-top-barcolor-input"
												sx={{
													marginTop: -2,
													fontWeight: 700,
													textTransform: "uppercase",
													fontSize: 12,
												}}
											>
												{t("general.topBarColor")}
											</InputLabel>
											<TextField
												id="app-top-barcolor-input"
												fullWidth
												disabled={[
													"building",
													"built",

													"publishing",
													"published",
													"inviting",
												].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
												variant="outlined"
												type="color"
												value={generalData.topbarColor}
												onChange={(e) => {
													setGeneralData({
														...generalData,
														topbarColor: e.target.value,
													});
												}}
											/>
											<Box
												sx={{
													backgroundColor: generalData.topbarColor,
													position: "absolute",
													top: "12px",
													left: "12px",
													width: "calc(100% - 24px)",
													height: "16px",
													outline: "1px solid",
													pointerEvents: "none",
													borderRadius: "2px",
												}}
											></Box>
										</FormControl>
										<FormControl
											fullWidth
											variant="standard"
											sx={{ marginTop: 2, marginBottom: 2 }}
										>
											<InputLabel
												shrink
												htmlFor="app-top-barcolor-text-input"
												sx={{
													marginTop: -2,
													fontWeight: 700,
													textTransform: "uppercase",
													fontSize: 12,
												}}
											>
												{t("general.topBarTextColor")}
											</InputLabel>
											<TextField
												id="app-top-barcolor-text-input"
												fullWidth
												disabled={[
													"building",
													"built",

													"publishing",
													"published",
													"inviting",
												].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
												variant="outlined"
												type="color"
												value={generalData.topbarTextColor}
												onChange={(e) => {
													setGeneralData({
														...generalData,
														topbarTextColor: e.target.value,
													});
												}}
											/>
											<Box
												sx={{
													backgroundColor: generalData.topbarTextColor,
													position: "absolute",
													top: "12px",
													left: "12px",
													width: "calc(100% - 24px)",
													height: "16px",
													outline: "1px solid",
													pointerEvents: "none",
													borderRadius: "2px",
												}}
											></Box>
										</FormControl>
										<FormControl
											fullWidth
											variant="standard"
											sx={{ marginTop: 2, marginBottom: 2 }}
											className={classes.pickerContainer}
										>
											<InputLabel
												shrink
												htmlFor="app-color-input"
												sx={{
													marginTop: -2,
													fontWeight: 700,
													textTransform: "uppercase",
													fontSize: 12,
												}}
											>
												{t("general.font")}
											</InputLabel>
											<TextField
												select
												labelId="demo-simple-select-label"
												id="demo-simple-select"
												value={generalData.fontFamily}
												fullWidth
												InputProps={{
													readOnly: ["building"].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													),
												}}
												variant="outlined"
												style={{ fontFamily: generalData.fontFamily }}
												onChange={(e) => {
													setGeneralData({
														...generalData,
														fontFamily: e.target.value,
													});
												}}
												disabled={[
													"building",
													"built",

													"publishing",
													"published",
													"inviting",
												].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
											>
												{[
													{ name: "Arimo" },
													{ name: "Barlow" },
													{ name: "Dosis" },
													{ name: "Heebo" },
													{ name: "Inconsolata" },
													{ name: "Inter" },
													{ name: "Josefin Sans" },
													{ name: "Kanit" },
													{ name: "Karla" },
													{ name: "Lato" },
													{ name: "Lora" },
													{ name: "Merriweather Sans" },
													{ name: "Merriweather" },
													{ name: "Montserrat" },
													{ name: "Mukta" },
													{ name: "Mulish" },
													{ name: "Nunito" },
													{ name: "Oswald" },
													{ name: "Oxygen" },
													{ name: "Poppins" },
													{ name: "Quicksand" },
													{ name: "Raleway" },
													{ name: "Roboto" },
													{ name: "Rubik" },
													{ name: "Ubuntu" },
												].map((font) => (
													<MenuItem
														style={{ fontFamily: font.name }}
														value={font.name}
													>
														{font.name}
													</MenuItem>
												))}
											</TextField>
										</FormControl>
										<FormControl
											fullWidth
											variant="standard"
											sx={{ marginTop: 2, marginBottom: 2 }}
										>
											<InputLabel
												shrink
												htmlFor="app-button"
												sx={{
													marginTop: -2,
													fontWeight: 700,
													textTransform: "uppercase",
													fontSize: 12,
												}}
											>
												{t("general.button")}
											</InputLabel>

											<FormControlLabel
												control={
													<Checkbox
														id="app-button"
														checked={generalData.buttonRounded}
														onChange={(e) => {
															setGeneralData({
																...generalData,
																buttonRounded: e.target.checked,
															});
														}}
														disabled={[
															"building",
															"built",
															"publishing",
															"published",
															"inviting",
														].find(
															(status) =>
																status ===
																(user.app.appStatuses.length === 0
																	? ""
																	: user.app.appStatuses.length > 0 &&
																	  user.app.appStatuses[0].status)
														)}
													/>
												}
												label={t("general.roundedButton")}
											/>

											<FormControlLabel
												control={
													<Checkbox
														id="app-button"
														checked={generalData.whiteTextButton}
														onChange={(e) => {
															setGeneralData({
																...generalData,
																whiteTextButton: e.target.checked,
															});
														}}
														disabled={[
															"building",
															"built",
															"publishing",
															"published",
															"inviting",
														].find(
															(status) =>
																status ===
																(user.app.appStatuses.length === 0
																	? ""
																	: user.app.appStatuses.length > 0 &&
																	  user.app.appStatuses[0].status)
														)}
													/>
												}
												label={t("general.whiteTextButton")}
											/>
										</FormControl>

										<FormControl
											fullWidth
											variant="standard"
											sx={{ marginTop: 2, marginBottom: 2 }}
										>
											<InputLabel
												shrink
												htmlFor="app-button"
												sx={{
													marginTop: -2,
													fontWeight: 700,
													textTransform: "uppercase",
													fontSize: 12,
												}}
											>
												{t("general.appAppearance") + " *"}
											</InputLabel>

											<RadioGroup
												aria-label="theme"
												name="theme"
												value={generalData.themeMode}
												onChange={(event) => {
													setGeneralData({
														...generalData,
														themeMode: event.target.value,
													});
												}}
												row
												disabled={[
													"building",
													"built",
													"publishing",
													"published",
													"inviting",
												].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
											>
												<FormControlLabel
													value="Light"
													control={<Radio />}
													label={t("general.lightMode")}
												/>
												<FormControlLabel
													value="Dark"
													control={<Radio />}
													label={t("general.darkMode")}
												/>
											</RadioGroup>
										</FormControl>
										<FormControl
											fullWidth
											variant="standard"
											sx={{ marginTop: 2, marginBottom: 2 }}
										>
											<InputLabel
												shrink
												htmlFor="app-top-barcolor-text-input"
												sx={{
													marginTop: -2,
													fontWeight: 700,
													textTransform: "uppercase",
													fontSize: 12,
												}}
											>
												{t("general.themeColorBackground")}
											</InputLabel>
											<TextField
												id="app-color-background"
												fullWidth
												disabled={[
													"building",
													"built",
													"publishing",
													"published",
													"inviting",
												].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
												variant="outlined"
												type="color"
												value={generalData.themeColor}
												onChange={(e) => {
													setGeneralData({
														...generalData,
														themeColor: e.target.value,
													});
												}}
											/>
											<Box
												sx={{
													backgroundColor: generalData.themeColor,
													position: "absolute",
													top: "12px",
													left: "12px",
													width: "calc(100% - 24px)",
													height: "16px",
													outline: "1px solid",
													pointerEvents: "none",
													borderRadius: "2px",
												}}
											></Box>
										</FormControl>
										<Typography
											sx={{
												fontWeight: 500,
												fontSize: 11,
												marginTop: 1,
											}}
										>
											{t("general.themeModeInfo")}
										</Typography>
									</Box>
									<Box
										sx={{
											width: {
												xs: "100%",
												sm: "100%",
												md: 388,
											},
											marginBottom: {
												xs: 4,
												sm: 4,
												md: 0,
											},
										}}
									>
										<Box
											sx={{
												width: "calc(100% - 40px)",
												aspectRatio: "1255 / 2582",
												margin: "auto",
												marginTop: 2,
												maxWidth: 260,
												borderRadius: "36px",
												overflow: "hidden",
												position: "relative",
											}}
										>
											<Box
												sx={{
													height: "12%",
													background: generalData.topbarColor,
													marginLeft: 1.25,
													display: "flex",
													justifyContent: "center",
													alignItems: "center",
													paddingTop: 4,
													borderTopLeftRadius: "32px",
													borderTopRightRadius: "40px",
												}}
											>
												<Typography
													sx={{
														color: generalData.topbarTextColor,
														fontSize: 12,
														fontWeight: "bold",
														fontFamily: generalData.fontFamily,
														marginLeft: -1.25,
													}}
												>
													{t("general.topBarText")}
												</Typography>
											</Box>
											<Box
												sx={{
													height:
														generalData.navigationType === "Drawer"
															? "92%"
															: "76%",
													marginLeft: 1.25,
													display: "flex",
													justifyContent: "flex-end",
													alignItems: "center",
													flexDirection: "column",
													paddingBottom: 8,
													backgroundColor: generalData.themeColor,
													borderBottomLeftRadius:
														generalData.navigationType === "Drawer"
															? "88px"
															: 0,
													borderBottomRightRadius:
														generalData.navigationType === "Drawer"
															? "88px"
															: 0,
												}}
											>
												<Typography
													sx={{
														color:
															generalData.themeMode === "Light"
																? "#000"
																: "#fff",
														fontSize: 12,
														fontWeight: "bold",
														fontFamily: generalData.fontFamily,
														marginLeft: -1.25,
														marginBottom: 5,
													}}
												>
													{t("general.appText")}
												</Typography>
												<Button
													variant="contained"
													size="small"
													sx={{
														borderRadius: generalData.buttonRounded
															? "50px"
															: 0,
														fontSize: 10,
														backgroundColor: generalData.color,
														fontFamily: generalData.fontFamily,
														marginLeft: -1.25,
														color: generalData.whiteTextButton
															? "white"
															: "black",
													}}
												>
													{t("general.button")}
												</Button>
											</Box>
											{generalData.navigationType === "Tab Bar" && (
												<Box
													sx={{
														height: "12%",
														background: generalData.navigationColor,
														borderTop: "1px solid #efefef",
														marginLeft: 1.25,
														display: "flex",
														justifyContent: "space-around",
														alignItems: "center",
														textAlign: "center",
														borderBottomLeftRadius: "32px",
														borderBottomRightRadius: "40px",
													}}
												>
													<Box
														sx={{
															textAlign: "center",
															marginTop: "-14px",
															marginLeft: -1.25,
															backgroundColor:
																generalData.color ===
																generalData.navigationColor
																	? "rgba(0, 0, 0, 0.03)"
																	: "transparent",
															borderRadius: "50%",
														}}
													>
														<Home
															size={14}
															color={
																generalData.color ===
																generalData.navigationColor
																	? generalData.navigationTextColor
																	: generalData.color
															}
														/>
														<Typography
															sx={{
																color:
																	generalData.color ===
																	generalData.navigationColor
																		? generalData.navigationTextColor
																		: generalData.color,
																fontSize: 8,
																fontWeight: "bold",
																textAlign: "center",
																marginTop: "-4px",
																fontFamily: generalData.fontFamily,
															}}
														>
															{t("general.home")}
														</Typography>
													</Box>
													<Box
														sx={{
															textAlign: "center",
															marginTop: "-14px",
														}}
													>
														<Settings
															size={14}
															color={generalData.navigationTextColor}
														/>
														<Typography
															sx={{
																color: generalData.navigationTextColor,
																fontSize: 8,
																fontWeight: "bold",
																textAlign: "center",
																marginTop: "-4px",
																fontFamily: generalData.fontFamily,
															}}
														>
															{t("general.settings")}
														</Typography>
													</Box>
												</Box>
											)}
											{generalData.navigationType === "Drawer" && (
												<Box
													sx={{
														position: "absolute",
														height: "100%",
														width: "45%",
														display: "flex",
														flexDirection: "column",
														justifyContent: "flex-start",
														top: 0,
														left: "10px",
														background: generalData.navigationColor,
														boxShadow: "1px 0px 5px rgb(0 0 0 / 5%)",
														paddingLeft: "16px",
														paddingTop: "40px",
														borderTopLeftRadius: "30px",
														borderBottomLeftRadius: "30px",
													}}
												>
													<Typography
														sx={{
															fontFamily: generalData.fontFamily,
															fontSize: 8,
															marginBottom: 4,
															color: generalData.navigationTextColor,
														}}
													>
														<b>Hi</b>
														<br />
														Jane
													</Typography>
													<Box
														sx={{
															display: "flex",
															alignItems: "flex-end",
															gap: 2,
															marginBottom: 2,
															backgroundColor:
																generalData.color ===
																generalData.navigationColor
																	? "rgba(0, 0, 0, 0.03)"
																	: "transparent",
														}}
													>
														<Home
															size={14}
															color={
																generalData.color ===
																generalData.navigationColor
																	? generalData.navigationTextColor
																	: generalData.color
															}
														/>
														<Typography
															sx={{
																color:
																	generalData.color ===
																	generalData.navigationColor
																		? generalData.navigationTextColor
																		: generalData.color,
																fontSize: 8,
																fontWeight: "bold",
																textAlign: "center",
																marginTop: "-4px",
																fontFamily: generalData.fontFamily,
															}}
														>
															{t("general.home")}
														</Typography>
													</Box>
													<Box
														sx={{
															display: "flex",
															alignItems: "flex-end",
															gap: 2,
														}}
													>
														<Settings
															size={14}
															color={generalData.navigationTextColor}
														/>
														<Typography
															sx={{
																color: generalData.navigationTextColor,
																fontSize: 8,
																fontWeight: "bold",
																textAlign: "center",
																marginTop: "-4px",
																fontFamily: generalData.fontFamily,
															}}
														>
															{t("general.settings")}
														</Typography>
													</Box>
												</Box>
											)}
											<img
												src={Iphone}
												alt="iphone"
												onMouseOver={() => {}}
												onMouseLeave={() => {}}
												style={{
													width: "100%",
													height: "100%",
													position: "absolute",
													top: 0,
													left: 0,
													outline: "30px solid white",
													borderRadius: 36,
												}}
											/>
										</Box>
									</Box>
								</Box>
							</>
						)}
					</CardContent>
					{!["inviting", "building", "built", "publishing", "published"].find(
						(status) =>
							status ===
							(user.app.appStatuses.length === 0
								? ""
								: user.app.appStatuses.length > 0 &&
								  user.app.appStatuses[0].status)
					) && (
						<CardActions sx={{ justifyContent: "right" }}>
							<Button
								variant="contained"
								size="small"
								onClick={saveGeneralData}
								disabled={loading}
								id="appearance-save"
							>
								{loading ? <CircularProgress size={12} /> : t("general.save")}
							</Button>
						</CardActions>
					)}
				</>
			</Card>
		</Box>
	);
}
